import { z } from "zod";
import { TObjectBase } from "../../base";
import {
  TRawBaseInfoField,
  TRawBooleanInfoFieldValue,
  TRawNumberInfoFieldValue,
  TRawStringInfoFieldValue,
  TRawTimestampInfoFieldValue,
} from "../../infoField";
import {
  TRawIncomeDataInfoFieldValue,
  TRawIndexRegulationInfoFieldValue,
  TRawJointAreaInfoFieldValue,
} from "./types";

/* @deprecated If possible, use the newer unit info field schemas with explicit typings for fields */
export type IInfoField = z.infer<typeof TInfoField>;
export const TInfoField = z
  .object({
    fields: z.record(
      z.object({
        suffix: z.string().optional(),
        value: z.any().nullable(),
        visibility: z.array(z.string()),
      }),
    ),
    visibility: z.array(z.string()),
  })
  .extend(TObjectBase.shape);

export type IRawUnitFinanceInfoFields = z.infer<
  typeof TRawUnitFinanceInfoFields
>;
export const TRawUnitFinanceInfoFields = z
  .object({
    accountNumber: TRawStringInfoFieldValue,
    contractConclusionDate: TRawTimestampInfoFieldValue,
    contractEndDate: TRawTimestampInfoFieldValue,
    contractStartDate: TRawTimestampInfoFieldValue,
    electricityRent: TRawNumberInfoFieldValue,
    fixedRegulation: TRawNumberInfoFieldValue,
    guarantee: TRawStringInfoFieldValue,
    incomeData: TRawIncomeDataInfoFieldValue,
    indexRegulation: TRawIndexRegulationInfoFieldValue,
    jointArea: TRawJointAreaInfoFieldValue,
    lastRegulation: TRawTimestampInfoFieldValue,
    optionDeadline: TRawTimestampInfoFieldValue,
    optionDuration: TRawNumberInfoFieldValue,
    optionNotification: TRawTimestampInfoFieldValue,
    receivesEhfInvoice: TRawBooleanInfoFieldValue,
    regulationInterval: TRawNumberInfoFieldValue,
    runningRenewal: TRawNumberInfoFieldValue,
    vatApplicable: TRawNumberInfoFieldValue.or(TRawBooleanInfoFieldValue),
    waterRent: TRawNumberInfoFieldValue,
  })
  .partial();

export const TApiUnitFinanceInfoFields = TRawUnitFinanceInfoFields.extend({
  contractConclusionDate: TRawStringInfoFieldValue,
  contractEndDate: TRawStringInfoFieldValue,
  contractStartDate: TRawStringInfoFieldValue,
  lastRegulation: TRawStringInfoFieldValue,
  optionDeadline: TRawStringInfoFieldValue,
  optionNotification: TRawStringInfoFieldValue,
}).partial();

export type IRawUnitLandlordAdminInfoFields = z.infer<
  typeof TRawUnitLandlordAdminInfoFields
>;
export const TRawUnitLandlordAdminInfoFields = z
  .object({
    marketRent: TRawNumberInfoFieldValue,
  })
  .partial();

export type IRawUnitNoteInfoFields = z.infer<typeof TRawUnitNoteInfoFields>;
export const TRawUnitNoteInfoFields = z
  .object({
    note: TRawStringInfoFieldValue,
  })
  .partial();

export type IRawUnitFinanceInfoField = z.infer<typeof TRawUnitFinanceInfoField>;
export const TRawUnitFinanceInfoField = z
  .object({
    fields: TRawUnitFinanceInfoFields.optional(),
  })
  .extend(TRawBaseInfoField.shape);

export type IRawUnitLandlordAdminInfoField = z.infer<
  typeof TRawUnitLandlordAdminInfoField
>;
export const TRawUnitLandlordAdminInfoField = z
  .object({
    fields: TRawUnitLandlordAdminInfoFields.optional(),
  })
  .extend(TRawBaseInfoField.shape);

export type IRawUnitNoteInfoField = z.infer<typeof TRawUnitNoteInfoField>;
export const TRawUnitNoteInfoField = z
  .object({
    fields: TRawUnitNoteInfoFields.optional(),
  })
  .extend(TRawBaseInfoField.shape);
